import React from "react";
var TableRow = function (_a) {
    var cell = _a.cell, columns = _a.columns, id = _a.id, rearrangeConfig = _a.rearrangeConfig, _b = _a.handleDrag, handleDrag = _b === void 0 ? function () { } : _b, _c = _a.handleDrop, handleDrop = _c === void 0 ? function () { } : _c;
    return (React.createElement("tr", { id: id, draggable: rearrangeConfig === null || rearrangeConfig === void 0 ? void 0 : rearrangeConfig.enable, onDragOver: function (ev) { return ev.preventDefault(); }, onDragStart: handleDrag, onDrop: handleDrop }, columns.map(function (column, index) {
        return (React.createElement("td", { key: "table-row-" + index, style: column.style || {
                minWidth: column.width ? column.width : "unset",
                textAlign: column.align,
            } }, column.render
            ? column.render(cell[column.id], cell, index)
            : cell[column.id]));
    })));
};
export default TableRow;
